import classNames from 'classnames';

import LogoLink from '../LogoLink/LogoLink';
import HamburgerMenu from './HamburgerMenu/HamburgerMenu';
import MegaMenu from './MegaMenu/MegaMenu';
import css from './SiteHeader.css';
import SiteHeaderState from './SiteHeaderState';
import SkipLink from './SkipLink/SkipLink';
import useSiteHeaderVisibility from './useSiteHeaderVisibility';

interface SiteHeaderProps {
  state: SiteHeaderState;
}

export default function SiteHeader({ state }: SiteHeaderProps) {
  const isVisible = useSiteHeaderVisibility();

  return (
    <>
      <SkipLink>{state.translation.skipLink}</SkipLink>
      <header className={classNames(css.root, { [css.hidden]: !isVisible })}>
        <div className={css.content}>
          <LogoLink href={state.homeUrl} />
          <MegaMenu className={css.megaMenu} state={state} />
          <HamburgerMenu className={css.hamburgerMenu} state={state} />
        </div>
      </header>
    </>
  );
}
